import { Link } from 'react-router-dom';

export default function RelatedLinks() {
  const relatedPages = [
    {
      icon: 'ri-trophy-line',
      title: '総合ランキング',
      description: '人気クレジットカードを総合的にランキング',
      href: '/ranking',
      color: 'from-amber-500 to-orange-500',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '年会費無料カード',
      description: 'コストゼロで持てるおすすめカード',
      href: '/free',
      color: 'from-emerald-500 to-teal-500',
    },
    {
      icon: 'ri-percent-line',
      title: '高還元率カード',
      description: 'ポイント還元率が高いカード特集',
      href: '/highreturn',
      color: 'from-rose-500 to-pink-500',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '学生向けカード',
      description: '学生でも作りやすいカード特集',
      href: '/student',
      color: 'from-sky-500 to-cyan-500',
    },
  ];

  const relatedArticles = [
    {
      title: '【2026年最新】即日発行できるクレジットカード',
      href: '/articles/instant-issue',
    },
    {
      title: '年会費無料でおすすめのクレジットカード',
      href: '/articles/free-annual-fee',
    },
    {
      title: 'ポイント還元率が高いクレジットカード比較',
      href: '/articles/high-return-rate',
    },
    {
      title: '大手ECモール系カードと三井住友カードを徹底比較',
      href: '/articles/rakuten-vs-mitsui',
    },
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block bg-gradient-to-r from-sky-100 to-cyan-100 text-sky-700 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold mb-4">
            🔗 関連コンテンツ
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            他のカテゴリも<span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">チェック</span>
          </h2>
        </div>

        {/* カテゴリリンク */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-10 sm:mb-14">
          {relatedPages.map((page, index) => (
            <Link
              key={index}
              to={page.href}
              className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br ${page.color} rounded-lg flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${page.icon} text-white text-lg sm:text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm sm:text-base mb-1 group-hover:text-sky-600 transition-colors">
                {page.title}
              </h3>
              <p className="text-gray-500 text-xs sm:text-sm">
                {page.description}
              </p>
            </Link>
          ))}
        </div>

        {/* 関連記事 */}
        <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center gap-2">
            <i className="ri-article-line text-sky-500"></i>
            関連記事
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {relatedArticles.map((article, index) => (
              <Link
                key={index}
                to={article.href}
                className="flex items-center gap-3 p-3 sm:p-4 bg-gray-50 hover:bg-sky-50 rounded-lg transition-colors group cursor-pointer"
              >
                <i className="ri-file-text-line text-gray-400 group-hover:text-sky-500 transition-colors"></i>
                <span className="text-gray-700 group-hover:text-sky-600 text-sm sm:text-base transition-colors">
                  {article.title}
                </span>
                <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-sky-500 ml-auto transition-colors"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
